<template>
  <div class="full">
    <img src="./img/Logo@2x.png" class="logo" />
    <label class="logo_span">Delauney</label>
    <div class="full">
      <a href="https://www.delauney.ltd/pc_index" target="_blank"
        ><span class="fwgw">Visit official website →</span></a
      >
      <div class="box-card" v-loading="loading">
        <!-- 填写邮箱 -->
        <div class="login_div" v-show="step == 1">
          <span class="login_span">Reset your password</span>
          <div class="sub_desc">
            We will send you an email to reset your password
          </div>
          <el-form
            :model="emailForm"
            :rules="emailRules"
            ref="emailForm"
            :hide-required-asterisk="true"
            @submit.native.prevent
          >
            <el-form-item prop="Email" label="Email" class="registerEn">
              <el-input
                type="text"
                v-model="emailForm.Email"
                auto-complete="off"
                placeholder="Email address"
                @input="validateEmail"
              ></el-input>
            </el-form-item>
            <el-button
              type="danger"
              class="login_submit"
              @click.native.prevent="nextStep(1)"
              >CONTINUE</el-button
            >
          </el-form>
        </div>
        <!-- 邮箱收到的验证码 -->
        <div class="code_div" v-show="step == 2">
          <div class="top">
            <span class="backup" @click="preStep">←</span>
            <span class="login_span">Verify your identity</span>
          </div>
          <div class="sub_desc">
            <span class="tip">Enter the code we've sent to</span>
            <span class="email">{{ emailForm.Email }}</span>
          </div>
          <el-form
            :model="codeForm"
            :rules="codeRules"
            ref="codeForm"
            @submit.native.prevent
          >
            <el-form-item prop="verificationCode" label="" class="registerEn">
              <el-input
                type="text"
                v-model="codeForm.verificationCode"
                auto-complete="off"
                placeholder="code"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="no_see">
            <span class="not_see">Don't see it? </span>
            <span class="resend">
              <el-button
                type="button"
                class="el_reg resend"
                :disabled="disabled"
                @click="smsCode"
              >
                <span v-if="time">{{ time }}s later </span>Resend code
              </el-button>
            </span>
          </div>
        </div>

        <!-- 重置密码 -->
        <div class="reset_box" v-show="step == 3">
          <span class="login_span">Change your password</span>
          <div class="sub_desc">
            Enter a new password bellow to change your password
          </div>
          <el-form
            :model="resetForm"
            :rules="resetRules"
            ref="resetForm"
            :hide-required-asterisk="true"
          >
            <el-form-item
              prop="newPassword"
              label="New password"
              class="registerEn"
            >
              <el-input
                type="text"
                v-model="resetForm.newPassword"
                @input="validatePassword"
                auto-complete="off"
                placeholder="newPassword"
                show-password
              ></el-input>
            </el-form-item>
            <template v-if="resetForm.newPassword">
              <p
                v-bind:class="{
                  'error-text': !containsAtLeastEightCharacters,
                  'true-text': containsAtLeastEightCharacters,
                }"
              >
                <span>{{ containsAtLeastEightCharacters ? "√" : "X" }}</span>
                Contains at least 8 characters
              </p>
              <p
                v-bind:class="{
                  'error-text': !containsBothLowerUpper,
                  'true-text': containsBothLowerUpper,
                }"
              >
                <span>{{ containsBothLowerUpper ? "√" : "X" }}</span>
                contains both lower (a-z) and upper case letters (A-Z)
              </p>
              <p
                v-bind:class="{
                  'error-text': !containsNumberOrSymbol,
                  'true-text': containsNumberOrSymbol,
                }"
              >
                <span>{{ containsNumberOrSymbol ? "√" : "X" }}</span>
                contains at least one number (0-9) or a symbol
              </p>
              <p
                v-bind:class="{
                  'error-text': !doesNotContainEmail,
                  'true-text': doesNotContainEmail,
                }"
              >
                <span>{{ doesNotContainEmail ? "√" : "X" }}</span>
                Does not contain your email address
              </p>
            </template>
            <el-form-item
              prop="confirmPassword"
              label="Confirm password "
              class="registerEn"
            >
              <el-input
                type="text"
                v-model="resetForm.confirmPassword"
                auto-complete="off"
                placeholder="confirmPassword"
                show-password
              ></el-input>
            </el-form-item>

            <el-button
              type="danger"
              class="submit"
              @click.native.prevent="handleSubmit"
              :loading="loading"
              >CHANGE PASSWORD</el-button
            >
          </el-form>
        </div>

        <!-- 重置成功 -->
        <div class="success_box" v-show="step == 4">
          <div class="success">🥳 Success!</div>
          <div class="text">Your password has been updated successfully</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API__code, API_ResetPwEn } from "../api/index.js";
export default {
  data() {
    return {
      step: 1,
      loading: false,
      time: 0,
      disabled: false,
      timer: null,
      // 邮箱
      emailForm: {
        Email: "",
      },
      emailChecked: false,
      emailRules: {
        Email: [
          {
            required: true,
            message: "Please enter your email address.",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Must be a valid email",
            trigger: ["blur", "change"],
          },
          {
            validator: this.checkVerificationEmail,
            trigger: "blur",
          },
        ],
      },
      // 验证码
      codeForm: {
        verificationCode: "",
      },
      codeRules: {
        verificationCode: [
          {
            required: true,
            message: "Please enter the verification code",
            trigger: "blur",
          },
          {
            validator: this.checkVerificationCode,
            trigger: "change",
          },
        ],
      },
      // 重置密码
      resetForm: {
        newPassword: "",
        confirmPassword: "",
      },
      resetRules: {
        newPassword: [
          {
            required: true,
            message: "Please enter your new password",
            trigger: ["blur", "change"],
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: "Please confirm your password",
            trigger: ["blur", "change"],
          },
          { validator: this.validateConfirmPassword, trigger: "blur" },
        ],
      },
      containsAtLeastEightCharacters: false,
      containsBothLowerUpper: false,
      containsNumberOrSymbol: false,
      doesNotContainEmail: false,
    };
  },
  methods: {
    // 邮箱验证
    async checkVerificationEmail(rule, value, callback) {
      // 可以添加一个标志位来判断是否已经校验过
      if (this.emailChecked) {
        callback();
        return;
      }
      try {
        const res = await API_ResetPwEn.verifyEmail({
          phone: value,
        });
        if (res.data.code == API__code.SUCCESS) {
          throw new Error(
            "This email isn't registered. Please check your input or sign up."
          );
        } else {
          this.emailChecked = true; // 标记为已校验
          callback();
        }
      } catch (error) {
        callback(error); // 失败时调用 callback
      }
    },
    //发送验证码
    smsCode() {
      if (this.emailForm.Email == "") {
        this.$message.error({
          message: "Email cannot be empty",
          center: true,
        });
        return;
      }
      this.loading = true;
      let para = {
        phone: this.emailForm.Email,
      };
      API_ResetPwEn.sendEmailCode(para)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.$message({
              message: "Send successful",
              type: "success",
              center: true,
            });
            this.step == 1 && (this.step = ++this.step);
            this.time = 60;
            this.disabled = true;
            this.timerFun();
          } else {
            this.$message.error(res.data.message);
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error("Server exception, please try again later..");
          this.loading = false;
        });
    },

    //60S倒计时
    timerFun() {
      if (this.time > 0) {
        this.time--;
        this.timer = setTimeout(this.timerFun, 1000);
      } else {
        this.time = 0;
        this.disabled = false;
      }
    },

    // 调接口查询验证码是否正确
    async checkVerificationCode(rule, value, callback) {
      if (!/^\d{6}$/.test(value)) {
        callback(new Error("Please enter a 6-digit verification code"));
        return;
      }
      this.loading = true;
      let params = {
        phone: this.emailForm.Email,
        smsCode: this.codeForm.verificationCode,
      };
      try {
        const res = await API_ResetPwEn.verifyEmailCode(params);
        if (res.data.code == API__code.SUCCESS) {
          this.$message({
            message: "Verification successful",
            type: "success",
            center: true,
          });
          callback();
          this.nextStep(2);
        } else {
          throw new Error(
            "The verification code is incorrect or has expired! Try again."
          );
        }
      } catch (error) {
        callback(error); // 失败时调用 callback
      } finally {
        this.loading = false;
      }
    },

    nextStep(curStep) {
      // 验证邮箱
      if (curStep == 1) {
        this.$refs.emailForm.validateField("Email", (valid) => {
          if (valid) {
            console.log("验证失败");
          } else {
            this.smsCode();
          }
        });
      }
      // 验证邮箱验证码
      else if (curStep == 2) {
        this.step = ++curStep;
      }
    },

    // 上一步
    preStep() {
      this.step = --this.step;
      this.codeForm.verificationCode = "";
      this.timer = null;
      this.time = 0;
      this.disabled = false;
    },
    // 邮箱标记重置
    validateEmail() {
      this.emailChecked = false;
    },
    // 密码规则校验
    validatePassword(val) {
      const email = this.emailForm.Email;
      this.containsAtLeastEightCharacters = /.{8,}/.test(val);
      this.containsBothLowerUpper = /[a-z]/.test(val) && /[A-Z]/.test(val);
      this.containsNumberOrSymbol = /\d|[^a-zA-Z\d\s]/.test(val);
      this.doesNotContainEmail = !val.includes(email);
    },

    // 确认密码校验
    validateConfirmPassword(rule, value, callback) {
      console.log("value", value);
      if (value !== this.resetForm.newPassword) {
        callback(new Error("The specified passwords must be identical"));
      } else {
        callback();
      }
    },

    handleSubmit() {
      this.$refs.resetForm.validate((valid) => {
        if (
          valid &&
          this.containsAtLeastEightCharacters &&
          this.containsBothLowerUpper &&
          this.containsNumberOrSymbol &&
          this.doesNotContainEmail
        ) {
          this.resetSubmit();
        } else {
          this.$message.error("Please correct the errors in the form.");
        }
      });
    },

    // 重置密码接口
    resetSubmit() {
      this.loading = true;
      let param = {
        password: this.resetForm.newPassword,
        conpassword: this.resetForm.confirmPassword,
        phone: this.emailForm.Email,
        smsCode: this.codeForm.verificationCode,
      };
      API_ResetPwEn.userPasswordEmail(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.$message({
              message: "Reset successful",
              type: "success",
            });
            this.step = ++this.step;
          } else {
            this.$message.error(res.data.message);
          }
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
          this.$message.error("Server exception, please try again later..");
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.full {
  min-width: 1000px;
  height: 100%;
  background-color: #f7f7f7;
}

.box-card {
  width: 540px;
  min-height: 165px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 45px 24px;
  position: relative;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: #fff;
}

.logo {
  width: 32px;
  height: 32px;
  position: absolute;
  left: 42px;
  top: 32px;
}

.logo_span {
  font-size: 20px;
  font-weight: bold;
  color: #1e1e1e;
  position: absolute;
  left: 85px;
  top: 35px;
  font-family: "思源黑体 CN Bold Bold";
}

.fwgw {
  color: #f66b3d;
  font-size: 16px;
  position: relative;
  float: right;
  right: 60px;
  top: 33px;
}

.sub_desc {
  color: #757575;
  font-size: 16px;
  font-weight: 400;
  margin: 20px 0;
}

.login_span {
  font-weight: bold;
  font-size: 24px;
  font-family: "思源黑体 CN Bold Bold";
  color: #f66b3d;
}

.login_div {
  text-align: center;
}

.registerEn {
  width: 400px;
  margin: 0 auto 5px;
  font-size: 16px;
}

.bak_en {
  color: #333333;
  font-size: 16px;
  position: absolute;
  float: left;
  left: 0px;
  top: -25px;
}

.login_submit {
  background-color: #f66b3d;
  width: 400px;
  height: 60px;
  font-size: 20px;
  font-weight: Normal;
  font-family: "思源黑体 CN Bold Bold";
  margin-top: 20px;
}

.code_div {
  .top {
    display: flex;
    justify-content: center;
    align-items: center;

    a {
      text-decoration: none;
    }

    .backup {
      color: #757575;
      font-size: 20px;
      margin-right: 20px;
      cursor: pointer;
    }
  }

  .sub_desc {
    text-align: center;
    margin-top: 20px;

    .tip {
      color: #757575;
      font-size: 16px;
    }

    .email {
      color: #1e1e1e;
      font-size: 16px;
      font-weight: 500;
      margin-left: 12px;
    }
  }

  .code {
    width: 400px;
    margin: 30px auto 0;
    display: flex;
  }

  .error {
    color: #f63d3d;
    font-size: 14px;
    font-weight: 500;
    margin: 30px auto 0;
    width: 400px;
    display: flex;
  }

  .no_see {
    width: 400px;
    display: flex;
    justify-content: flex-end;
    margin: 30px auto;

    .not_see {
      color: #1e1e1e;
      font-size: 16px;
      font-weight: 500;
    }

    .resend {
      color: #f66b3d;
      font-size: 16px;
      font-weight: 500;
      margin-left: 12px;
    }

    .el_reg {
      border: white;
      padding: 0;
    }

    .el_reg:hover {
      background-color: white;
    }

    .el-button.is-disabled,
    .el-button.is-disabled:hover {
      color: #c0c4cc;
    }
  }
}

.reset_box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .sub_desc {
    width: 320px;
    text-align: center;
    margin-bottom: 20px;
  }

  .submit {
    margin-top: 20px;
    background-color: #f66b3d;
    width: 400px;
    height: 60px;
    font-size: 20px;
    font-weight: Normal;
    font-family: "思源黑体 CN Bold Bold";
  }

  .error-text {
    color: #f63d3d;
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .true-text {
    color: #146801;
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 8px;
  }
}

.success_box {
  display: flex;
  height: 160px;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .success {
    color: #f66b3d;
    font-size: 24px;
    font-weight: 700;
  }

  .text {
    color: #1e1e1e;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?57750b38